var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.canManage)?_c('v-alert',{staticClass:"mb-0",attrs:{"type":"info","dense":"","icon":"mdi-account-wrench"}},[_vm._v(" As configurações deste evento só podem ser alteradas por técnicos. Entre em contato com o suporte para solicitar uma alteração. ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }